function Footer() {
    return (
        <footer className="text-center text-white border-top">
            <div className="text-center p-3">
                <p className="text-white mb-0">&copy;{(new Date().getFullYear())} All rights reserved: Victor B&#226;ldea</p>
            </div>
        </footer>
    );
};

export default Footer;